import { connect as baseConnect } from 'react-refetch';

// return the user data from the session storage
export const getUser = () => {
    const userStr = sessionStorage.getItem('user');
    // console.warn('dato pescato da sessionStorage:', userStr);
    if (userStr) return JSON.parse(userStr);
    else return null;
  }
   
  // return the token from the session storage
  export const getToken = () => {
    return sessionStorage.getItem('token') || '';
  }
   
  // remove the token and user from the session storage
  export const removeUserSession = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  }
   
  // set the token and user from the session storage
  export const setUserSession = (token, user) => {
    // console.warn('dato che mi arriva da ws login:', user);
    if (typeof user === 'object' && user !== null) {
      user.u_id = null;
      user.password = null;
    }
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  export const isAuthenticated = () => {
    if (getUser() == null) {
      console.warn('non autenticato!!')
      return false;
    }
    return true;
  }

  export function catch401s(reason, meta) {
    if (meta.response != null && meta.response.status === 401) {
      localStorage.removeItem("token");
      sessionStorage.removeItem('user');
      const error = Promise.reject(
        new Error(
          'Utente non autenticato o non riconosciuto. Collegarsi al sistema di autenticazione di ateneo e riprovare.'
        )
      );
      return {
        meta,
        value: error,
      };
    }
    if (meta.response != null && meta.response.status === 403) {
      //console.warn('arrivato al controllo di autorizzazione');
      const error = Promise.reject(
        {
          cause: {
            description: 'Utente non autorizzato. Collegarsi al sistema di autenticazione di ateneo altre credenziali e riprovare.'
          }
        }
      );
      return {
        meta,
        value: error,
      };
    }
    return undefined;
  }

  function newError(cause) {
    const e = new Error(parse(cause));
    e.cause = cause;
    return e;
  }
  
  function parse(cause) {
    const { errorMsg, returnMsg } = cause;
  
    if (errorMsg) {
      return errorMsg;
    } else if (returnMsg) {
      return returnMsg;
    } else {
      return '';
    }
  }
  
  export const connect = baseConnect.defaults({
    handleResponse(response) {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      } else {
        const copy = response.clone();
        const json = response.json();
        return json.then(
          (cause) => Promise.reject(newError(cause)),
          () => copy.text().then((text) => Promise.reject(new Error(text)))
        );
      }
    },
    credentials: 'include',
  });